import api from "@/services/api";

const methods = api.getPrefixedMethods("settings");

export const settingsService = {
  getCustomTags() {
    return methods.get("tags");
  },
  updateCustomTags(scope, tags) {
    return methods.put("tags", { scope, tags });
  },
  resetCustomTags(scope) {
    return methods.delete("tags", { params: { scope } });
  },
  getMyActionNeeded() {
    return methods.get("action-needed/me");
  },
  updateMyActionNeededChip(scope, showChip) {
    return methods.put("action-needed/me", { scope, showChip });
  },
  getPriorAuthStatusChangeEmailsEnabled() {
    return methods.get("prior-auth-status-change-emails-enabled");
  },
  updatePriorAuthStatusChangeEmailsEnabled(enabled) {
    return methods.put("prior-auth-status-change-emails-enabled", { enabled });
  },
  getPriorAuthStatusChangeNotfStatuses() {
    return methods.get("prior-auth-status-change-notf-statuses");
  },
  updatePriorAuthStatusChangeNotfStatuses(statuses) {
    return methods.put("prior-auth-status-change-notf-statuses", { statuses });
  },
};
